module.exports = __webpack_public_path__ + "static/media/material-thumbs-up.48eb0487.svg";